/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

export const baseUrl: any = process.env.REACT_APP_BASE_URL;

export const htmlCodeAssist = (code: string) => {
    const parser = new DOMParser();
    return parser.parseFromString(code, 'text/html').body.textContent;
}

export const debug = (category: string, message: string) => {
    const enabled: any = process.env.REACT_APP_DEBUG;
    if(enabled) {
        if(category) {
            console.log(category + " : " + message);
        } else {
            console.log(message);
        }
    }
}

export const formatDateFull = (dateString: string): string => {
   /* const theDate = new Date(dateString);
    return theDate.toLocaleDateString().replaceAll("\/", "-") + " " + theDate.toLocaleTimeString(); */
    //console.log(dateString);

    if(dateString) {
        const theDate = new Date(dateString);
        // Check if the dateString is empty or invalid
        if (isNaN(theDate.getTime())) {
            return '-';
        }

        const dateOptions: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        };
        const timeOptions: Intl.DateTimeFormatOptions = {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        };

        const formattedDate = theDate.toLocaleDateString('en-GB', dateOptions).replace(/\//g, '-'); // "en-GB" forces DD-MM-YYYY format
        let formattedTime = theDate.toLocaleTimeString('en-GB', timeOptions);

        // Change AM/PM to uppercase
        //formattedTime = formattedTime.replace(/(am|pm)/i, (match) => match.toUpperCase());

        // Determine AM or PM manually based on the 24-hour format
        const hour = theDate.getHours();
        const amPm = hour >= 12 ? 'PM' : 'AM';
 
         return `${formattedDate} ${formattedTime} ${amPm}`;

       // return `${formattedDate} ${formattedTime}`;
    } else {
        return "";
    }
}




export const formatDateShort = (dateString: string): string => {
    const theDate = new Date(dateString);
    return theDate.toLocaleDateString().replaceAll("\/", "-");
}


export const fetchRecords = async (endpoint: string, processData: any) => {

    const fullUrl = baseUrl + "/" + endpoint;
    debug("fetchRecords", "Configured to use " + fullUrl);
    
    const response = await fetch(fullUrl);
    if(!response.ok) {
        throw new Error("Invalid Response Status : " + response.status + " - " + response.statusText);
    }

    const responseJson = await response.json();
    processData(responseJson);
}

export const fetchMultiSourceRecords = async (endpoints: string[], processData: any) => {
    
    const fullPathEndPoints: any[] = [];

    for(let e in endpoints) {
        fullPathEndPoints.push(
            fetch(baseUrl + "/" + endpoints[e])
        );
    }

    const result = (
        await Promise.all(fullPathEndPoints)
    ).map((r) => r.json());

    const results: any[] = await Promise.all(result);
    processData(results);
}

// Use this function to post fromData from the modals.
export const postFormData = async (endpoint: string, formData: any, callbackSuccess?: any, callbackError?: any) => {

    try {
        const fullUrl = baseUrl + "/" + endpoint;
        
        debug("postFormData", "Configured to use " + fullUrl);
        debug("postFormData", "Payload - " + JSON.stringify(formData));

        let response = await fetch(fullUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer <token>'
            },
            body: JSON.stringify(formData)
        });
        let responseJson = response.json();
        if(response.status === 200) {
            callbackSuccess();
        } else {
            callbackError(response);
            debug("postFormData", "Invalid response: " + response.status + " - " + response.statusText);
        }
    } catch (error) {
        debug("postFormData", "Error - " + error);
    }
}

export const validateEmail = (email: string): boolean => {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}